import httpMultipart from "@/http-multipart";
import http from "../../http-common";

class SurveyForm {
    create(formData) {
        return httpMultipart.post("/form/create-form", formData);
    }

    getDataTableSurveyForm(data) {
        return http.get(`/form/search-form`, {params: data})
    }
    deleteFormById(idList){
        const query = idList.map(id => `id=${id}`).join('&');
        return http.delete(`/form?${query}`);
    }

    getDataFormById(id) {
        return http.get(`/form/detail-form?id=${id}`);
    }

    getDataAnswerUser(idForm, type, id) {
        return http.get(`/form/detail-form-user?idForm=${idForm}&typeUserApply=${type}&idUser=${id}`);
    }

    deleteDataAnswer(idForm, typeUser, idUser) {
        return http.delete(`/form/deleteAnswer?idForm=${idForm}&typeUserApply=${typeUser}&idUser=${idUser}`);
    }

    update(formData) {
        return httpMultipart.put("/form", formData);

    }

    updateApply(idKids, idTeachers, idForm) {
        const param = {
            listIdKids: idKids,
            listIdTeacher: idTeachers,
            id: idForm,
        }

        return http.put(`/form/apply-toggle`, param)
    }

    getDataListFormSys() {
        return http.get(`/form/formSys`, )
    }

    getAllKidsSchool() {
        return http.get(`/form/get_kids_school`);
    }

    getAllKidsClass() {
        return http.get(`/form/get_kids_by_teacher`);
    }

    getAllEmployeesSchool() {
        return http.get(`/form/get_employees_school`)
    }

    getDataFilterApplicable(formData) {
        return httpMultipart.post(`/form/searchManagement`, formData)
    }

    getAllForm() {
        return http.get(`/form/form-idSchool`)
    }

    exportExcelStatistical(id) {
        return http.get(`/form/exportExel-form?idForm=${id}`)
    }
    restoreForm(id) {
        return http.get(`/form/restore-form?idForm=${id}`)
    }

}

export default new SurveyForm();